/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-type is a library for typechecking of props
import PropTypes from 'prop-types'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import SoftInput from 'components/SoftInput'
import { NumericFormat } from 'react-number-format'

const CurrencyField = ({ value, label, onChange, ...rest }) => {
  return (
    <SoftBox
      display="flex"
      flexDirection="column"
      justifyContent="flex-end"
      height="auto"
    >
      <SoftBox ml={0.5} lineHeight={0} display="inline-block">
        <SoftTypography
          component="label"
          variant="body2"
          fontWeight="regular"
          textTransform="capitalize"
        >
          {label}
        </SoftTypography>
      </SoftBox>
      <NumericFormat
        value={value}
        prefix="$"
        thousandSeparator
        inputProps={{ inputMode: 'numeric' }}
        customInput={SoftInput}
        onValueChange={(values) => {
          onChange(values.floatValue || 0)
        }}
        {...rest}
      />
    </SoftBox>
  )
}

// typechecking props for CurrencyField
CurrencyField.propTypes = {
  label: PropTypes.string.isRequired,
}

export default CurrencyField
